import api from './api';

export interface User {
  user_id: string;
  id: number;
  full_name: string;
  email: string;
  role: number;
  status: 'active' | 'inactive';
  phone_no: string;
  position?: number;
  department: string;
  avatar_url?: string;
  joined_date: string;
  created_at: string;
  updated_at: string;
  firm_id: number;
}

export interface UserCreateInput {
  full_name: string;
  email: string;
  password: string;
  role: number;
  position?: number;
  phone_no: string;
  department: string;
  status?: string;
  firm_id?: number;
}

export interface UserUpdateInput extends Partial<Omit<UserCreateInput, 'password'>> {
  user_id: string;
  firm_id?: number;
  id?: number;
  password?: string;
}

const usersService = {
  getUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  getUserById: async (userId: number) => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  createUser: async (data: UserCreateInput) => {
    const response = await api.post('/users', data);
    return response.data;
  },

  updateUser: async (data: UserUpdateInput) => {
    const response = await api.put(`/users/${data.user_id}`, data);
    return response.data;
  },

  deleteUser: async (userId: number) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  updateUserStatus: async (userId: number, status: string) => {
    const response = await api.put(`/users/${userId}/status`, { status });
    return response.data;
  },

  resetPassword: async (userId: number, newPassword: string) => {
    const response = await api.put(`/users/${userId}/reset-password`, { password: newPassword });
    return response.data;
  },

  searchUsers: async (query: string) => {
    const response = await api.get(`/users/search?query=${query}`);
    return response.data;
  },

  getRoles: async () => {
    const response = await api.get('/users/roles');
    return response.data;
  },

  getPositions: async () => {
    const response = await api.get('/users/positions');
    return response.data;
  },
};

export default usersService;
